// DimensionsCard.tsx — the object's measured dimensions: oriented length ×
// width in the marker plane, height above it, the voxel volume estimate and
// how many gaussians the measurement used. Read-only, so header + body only.
import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table';
import type { DimensionsResult, Scan } from '../api';
import { fmtMm } from '../format';

export interface DimensionsCardProps {
  scan: Scan;
  dims: DimensionsResult | null;
}

export function DimensionsCard({ scan, dims }: DimensionsCardProps) {
  const d = dims ?? scan.dimensions;
  return (
    <Card>
      <Card.Header>Dimensions</Card.Header>
      <Card.Body>
        {d ? (
          <Table size="sm" borderless className="m-0">
            <tbody>
              <tr>
                <td>Length</td>
                <td className="measure-value text-end">{fmtMm(d.length_mm)}</td>
              </tr>
              <tr>
                <td>Width</td>
                <td className="measure-value text-end">{fmtMm(d.width_mm)}</td>
              </tr>
              <tr>
                <td>Height</td>
                <td className="measure-value text-end">{fmtMm(d.height_mm)}</td>
              </tr>
              <tr>
                <td>Volume</td>
                <td className="measure-value text-end">{d.volume_cm3.toFixed(1)} cm³</td>
              </tr>
              {dims && (
                <tr>
                  <td>Gaussians used</td>
                  <td className="text-end">{dims.count}</td>
                </tr>
              )}
            </tbody>
          </Table>
        ) : (
          <span className="text-body-secondary small">
            {scan.status === 'ready' ? 'No object segmented yet — run segmentation below.' : 'Available once refinement finishes.'}
          </span>
        )}
      </Card.Body>
    </Card>
  );
}
